'use client';

import { Autocomplete, FormControl, TextField } from '@mui/material';
import React from 'react';

import { getSelectedRate } from '../../../utils';

export const RateAutoComplete = ({
	id,
	rateKey,
	label,
	formData,
	rates,
	handleInputChangeLeasingRight,
	disabled,
	index = 0,
	required = true,
	InputProps = {},
	InputLabelProps = {},
}) => {
	const shouldDisableRate = () => {
		if (!formData.leasingCountAndRateHistory.length) return true;
		return false;
	};

	return (
		<FormControl style={{ width: '100%' }}>
			<Autocomplete
				id={id}
				value={getSelectedRate(rates, formData, rateKey)}
				onChange={(_, value) => {
					if (disabled) return;
					handleInputChangeLeasingRight(
						{
							target: {
								name: rateKey,
								value: value?.rateId || '',
							},
						},
						index,
					);
				}}
				disabled={disabled}
				getOptionLabel={(option) => option?.name || ''}
				options={rates.map((rate) => ({
					rateId: rate.id,
					name: rate.name,
					shouldBeDisabled: shouldDisableRate(),
				}))}
				isOptionEqualToValue={(option, value) => option.rateId === value.rateId}
				getOptionDisabled={(option) => option.shouldBeDisabled}
				renderInput={(params) => (
					<TextField
						{...params}
						required={required}
						value={formData[rateKey]}
						label={label}
						disabled={disabled}
						inputProps={{ ...params.inputProps, 'data-cy': 'rate-name-select' }}
						InputProps={{ ...params.InputProps, ...InputProps }}
						InputLabelProps={{ ...params.InputLabelProps, ...InputLabelProps }}
					/>
				)}
			/>
		</FormControl>
	);
};
